import { render, staticRenderFns } from "./PdfProductTable.vue?vue&type=template&id=297f6459&scoped=true&"
import script from "./PdfProductTable.vue?vue&type=script&lang=js&"
export * from "./PdfProductTable.vue?vue&type=script&lang=js&"
import style0 from "./PdfProductTable.vue?vue&type=style&index=0&id=297f6459&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f6459",
  null
  
)

export default component.exports